declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
    fbq?: (...args: any[]) => void;
    _analyticsInitialized?: boolean;
  }
}

export function initAnalytics() {
  if (typeof window === 'undefined') return;
  // No-op: GA and Meta Pixel are loaded via hardcoded scripts in public/index.html
}

export function trackSignupComplete() {
  if (typeof window === 'undefined') return;

  if (typeof window.fbq === 'function') {
    window.fbq('track', 'CompleteRegistration');
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'sign_up', {
      method: 'email',
    });
  }
}

export function trackDemoStartForFarmClicked() {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'demo_start_for_farm_clicked');
  }
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', 'DemoStartForFarmClicked');
  }
}

export function trackAuthOpenedFromDemo() {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'auth_opened_from_demo');
  }
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', 'AuthOpenedFromDemo');
  }
}

export function trackSignupCompletedFromDemo() {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'signup_completed_from_demo');
  }
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', 'SignupCompletedFromDemo');
  }
}

